import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/commun.css';
import axios from 'axios';

Vue.config.productionTip = false;
Vue.use(ElementUI);


Vue.prototype.$axios = axios

router.beforeEach((to, from, next)=>{
  document.title = "报单系统"
   next()
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
